import React, { useState, useEffect } from "react";
import axios from "axios";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";
import "../../css/Gallery.css";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_GALLERY = `${BASE_URL}getpagedata/get_webgallery.php`;
const IMG_BASE = `${BASE_URL}admin/assets/gallery/`;

export default function Gallery() {

  const [gallery, setGallery] = useState([]);
  const [albums, setAlbums] = useState([]);
  const [activeAlbum, setActiveAlbum] = useState("");

  /* ================= LOAD DATA ================= */
  useEffect(() => {
    fetchGallery();
  }, []);

  const fetchGallery = async () => {
    try {
      const res = await axios.get(API_GALLERY);

      if (res.data.success) {

        const data = res.data.data;
        setGallery(data);

        // Extract unique album names
        const uniqueAlbums = [...new Set(data.map(item => item.name))];
        setAlbums(uniqueAlbums);

        if (uniqueAlbums.length > 0) {
          setActiveAlbum(uniqueAlbums[0]);
        }
      }

    } catch (error) {
      console.error("Gallery load error:", error);
    }
  };

  /* ================= FANCYBOX ================= */
  useEffect(() => {
    Fancybox.bind("[data-fancybox='gallery']", {
      Thumbs: true,
      Toolbar: true,
    });

    return () => {
      Fancybox.destroy();
    };

  }, [activeAlbum]);

  /* ================= FILTER ================= */
  const filteredImages = gallery.filter(
    (img) => img.name === activeAlbum
  );

  return (
    <div className="section gallery-section">
      <div className="container">

        {/* FILTER BUTTONS */}
        <div className="text-center mb-4">
          {albums.map((album) => (
            <button
              key={album}
              className={`btn gallery-btn mx-1 ${
                activeAlbum === album ? "active" : ""
              }`}
              onClick={() => setActiveAlbum(album)}
            >
              {album.toUpperCase()}
            </button>
          ))}
        </div>
           <p><br></br></p>
        {/* IMAGE GRID */}
        <div className="row">
          {filteredImages.map((item) => (
            <div
              key={item.id}
              className="col-sm-6 col-md-4 gallery-item mb-4 fade-in"
            >
              <a
                data-fancybox="gallery"
                data-caption={item.name}
                href={IMG_BASE + item.image}
              >
                <img
                  src={IMG_BASE + item.image}
                  className="img-fluid rounded shadow"
                  alt={item.name}
                />
              </a>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}